// Tiny zero-dependency Web Audio sound effects + confetti.

let audioCtx = null;
const getCtx = () => {
 if (!audioCtx) {
 try { audioCtx = new (window.AudioContext || window.webkitAudioContext)(); } catch { return null; }
 }
 return audioCtx;
};

function tone(freq, ms, type = "sine", gain = 0.15, glide = 0) {
 const ctx = getCtx(); if (!ctx) return;
 const o = ctx.createOscillator(); const g = ctx.createGain();
 o.type = type; o.frequency.value = freq;
 o.connect(g); g.connect(ctx.destination);
 const now = ctx.currentTime;
 g.gain.setValueAtTime(gain, now);
 g.gain.exponentialRampToValueAtTime(0.0001, now + ms/1000);
 if (glide) o.frequency.exponentialRampToValueAtTime(Math.max(freq + glide, 30), now + ms/1000);
 o.start(now); o.stop(now + ms/1000);
}

export const sfx = {
 gavel: () => { tone(160, 120, "square", 0.25, -60); setTimeout(() => tone(110, 220, "square", 0.18, -50), 90); },
 drop: () => { tone(440, 90, "triangle", 0.12); setTimeout(() => tone(220, 180, "triangle", 0.14, -100), 80); },
 victory: () => { tone(523, 100, "square", 0.13); setTimeout(()=>tone(659, 120, "square", 0.13), 110); setTimeout(()=>tone(880, 200, "square", 0.14), 250); },
 defeat: () => { tone(330, 220, "sawtooth", 0.13, -150); },
 click: () => { tone(700, 30, "sine", 0.08); },
 unlock: () => { tone(880, 80, "triangle", 0.14); setTimeout(()=>tone(1318, 120, "triangle", 0.12), 90); },
};

/** Burst CSS-based confetti from window center. */
export function confetti(opts = {}) {
 const count = opts.count || 80;
 const colors = ["#FFD700", "#E60000", "#FFFFFF", "#00FF41"];
 const root = document.body;
 for (let i = 0; i < count; i++) {
 const el = document.createElement("div");
 const c = colors[i % colors.length];
 Object.assign(el.style, {
 position: "fixed",
 top: "30%", left: "50%",
 width: `${6 + Math.random()*6}px`,
 height: `${10 + Math.random()*12}px`,
 background: c,
 zIndex: 9999,
 pointerEvents: "none",
 transform: `translate(-50%, -50%) rotate(${Math.random()*360}deg)`,
 opacity: "1",
 transition: `transform 1.6s cubic-bezier(.2,.6,.4,1), top 1.6s cubic-bezier(.2,.6,.4,1), opacity 1.6s ease-out`,
 });
 root.appendChild(el);
 requestAnimationFrame(() => {
 el.style.top = `${110 + Math.random()*10}%`;
 el.style.transform = `translate(${(Math.random()-0.5)*900}px, 0) rotate(${Math.random()*720}deg)`;
 el.style.opacity = "0";
 });
 setTimeout(() => el.remove(), 1900);
 }
}
